// 河北光合动力有限公司处理
import { buildOnline } from "@/utils/global"
import _ from "lodash"

export const HeibeiGuangHeDongLi = {
    CompanyId: 139,
}

export function isHeibeiGuangHeDongLi(store) {
    if (!buildOnline) {
        return false
    }
    return _.get(store, 'getters.currentParentCompany') === HeibeiGuangHeDongLi.CompanyId
}
